/**
 * Global namespace for most components `target` option.
 */
const dataBsTarget = 'data-bs-target';
export default dataBsTarget;
